import React from 'react';

// 預訂頁供應商摺疊列：一行標題＋右邊小字來源，點擊展開內容。
// 由外層控制 open / onToggle，方便做「一次只開一行」。
// keepMounted：收起時只隱藏不卸載（用於 Trip.com iframe，避免每次展開都重新載入）
const FoldRow = ({ title, subtitle, source, sourceColor = '#64748b', open, onToggle, keepMounted = false, children }) => (
  <div style={{ borderRadius:12, border:'1.5px solid #e2e8f0', background:'#fff', overflow:'hidden' }}>
    <button onClick={onToggle} aria-expanded={open}
      style={{ width:'100%', display:'flex', alignItems:'center', gap:10, padding:'11px 14px', border:'none', background:'transparent', cursor:'pointer', textAlign:'left' }}>
      <span style={{ flex:1, minWidth:0 }}>
        <span style={{ display:'block', fontSize:13, fontWeight:900, color:'#0f172a' }}>{title}</span>
        {subtitle && <span style={{ display:'block', fontSize:11, color:'#64748b', fontWeight:600, marginTop:2 }}>{subtitle}</span>}
      </span>
      {source && <span style={{ fontSize:10, fontWeight:800, color:sourceColor, flexShrink:0 }}>{source}</span>}
      <span style={{ fontSize:12, color:'#64748b', flexShrink:0, transform: open ? 'rotate(180deg)' : 'none', transition:'transform 0.15s' }}>▾</span>
    </button>
    {(open || keepMounted) && <div hidden={!open} style={{ padding:'0 14px 12px' }}>{children}</div>}
  </div>
);

export default FoldRow;
